import { LogoAndBrand } from '@src/common/components/brand/LogoAndBrand';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import Config from '@src/config/Config';
import { useTranslation } from 'react-i18next';

export const PublicPortalInvalidLink = () => {
  const { t } = useTranslation();
  const brand = Config.VITE_BRAND;
  const brandEmail = Config.VITE_BRAND_EMAIL;
  const brandPhone = Config.VITE_BRAND_PHONE;

  return (
    <Stack
      direction="column"
      alignItems="center"
      spacing={1.5}
      sx={{ px: 3, textAlign: 'center' }}
    >
      <LogoAndBrand width={120} height={80} />
      <Typography variant="h5">
        {t('publicPortal.error.invalid.title')}
      </Typography>
      <Typography variant="body1">
        {t('publicPortal.error.invalid.message', {
          brand,
          email: brandEmail,
          phone: brandPhone,
        })}
      </Typography>
    </Stack>
  );
};
